module.exports = __webpack_public_path__ + "static/img/avatar-man.529a7a50.png";